import { useState } from "react";

const PastYear2021 = () => {
    const [isHovering] = useState(false);

    const styles = {
        container: {
            height: "auto",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            color: "white"
        },
        content: {
            position: "relative" as "relative",
            height: "auto",
            maxHeight: "95%",
            width: "95%",
            maxWidth: "1280px",
            fontSize: "22px",
            fontFamily: "'Raleway', Arial",
            padding: "130px 0px",
            margin: "auto",
            verticalAlign: "middle",
            textAlign: "center" as "center",
        },
        contentAlt: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            //position: "relative",
            display: "block",
            height: "100%",
            width: "100%",
            color: "#FFF",
            fontSize: "20px",
            fontWeight: "300",
            fontFamily: "'Raleway', Arial, sans-serif",
            padding: "100px 0px",
            margin: "auto",
            verticalAlign: "middle",
            textAlign: "center" as "center",
        },
        sectionTitle: {
            fontSize: "32px",
            margin: "0px",
            fontWeight: "normal",
        },
        sectionTitleAlt: {
            color: "#FFF",
            fontSize: "32px",
            paddingBottom: "20px",
            margin: "0px",
            fontWeight: "normal",
        },
        newsArticles: {
            width: "95%",
            maxWidth: "1280px",
            textAlign: "left" as "left",
            margin: "30px auto",
            fontWeight: "300",
        },
        button: {
            margin: "10px",
            padding: "10px 20px",
            fontSize: "18px",
            backgroundColor: "#141619",
            color: "white",
            border: "1px solid #ddd",
            borderRadius: "8px",
            cursor: "pointer",
        },
        activeButton: {
            backgroundColor: "#050A44",
        },
    }
    return (
        <div className="container" style={styles.container}>
            <div className="content"
            style={{
                ...styles.content,
                color: "white",
                backgroundColor: "#141619",
                maxWidth: 1280,
                margin: "0px auto 0px",
            }}>
                <h1 style={{ color: "#1d77d7", fontSize: "60px", alignContent: "center", fontFamily: "'NCAA Missouri Tigers', Arial", }}>Jelly</h1>
                <p className="sectionTitle" style={styles.sectionTitle}>2021-2022</p>
                <br />
                <div>
                <img
                    src="/images/jellyPhotos/Jelly_IsoV2.png"
                    alt="isoView"
                    id="subImg"
                    style={{ 
                        padding: "clamp(15px, 5vw, 40px)", 
                        borderRadius: "8px",
                        backgroundColor: "#131c81",
                        marginBottom: "20px",
                        maxWidth: "100%",
                        width: "clamp(250px, 90vw, 800px)",
                        height: "auto",
                        objectFit: "contain"
                    }}
                />
                </div>
                <img
                    src="/images/jellyPhotos/Jelly_TopV2.png"
                    alt="topView"
                    style={{
                        maxWidth: "clamp(180px, 30vw, 300px)",
                        height: "auto",
                        verticalAlign: "middle",
                        padding: "clamp(10px, 2vw, 20px)",
                        borderRadius: "8px",
                        backgroundColor: "#131c81",
                        margin: "10px",
                        display: "inline-block"
                    }}
                />
                <img
                    src="/images/jellyPhotos/Jelly_FrontV2.png"
                    alt="frontView"
                    style={{
                        maxWidth: "clamp(180px, 30vw, 300px)",
                        height: "auto",
                        verticalAlign: "middle",
                        padding: "clamp(10px, 2vw, 20px)",
                        margin: "clamp(5px, 2vw, 20px)",
                        borderRadius: "8px",
                        backgroundColor: "#131c81",
                        display: "inline-block"
                    }}
                />
                <img
                    src="/images/jellyPhotos/Jelly_BottomV2.png"
                    alt="bottomView"
                    style={{
                        maxWidth: "clamp(200px, 35vw, 350px)",
                        height: "auto",
                        verticalAlign: "middle",
                        padding: "clamp(10px, 2vw, 20px)",
                        borderRadius: "8px",
                        backgroundColor: "#131c81",
                        margin: "10px",
                        display: "inline-block"
                    }}
                />
                <br />
                <br />
                <br />
                <div style={{ margin: "auto", maxWidth: "100%", overflow: "hidden" }}>
                    <iframe
                        style={{
                            maxWidth: "100%",
                            width: "clamp(280px, 90vw, 560px)",
                            height: "clamp(158px, 50vw, 315px)",
                            border: "none"
                        }}
                        src="https://www.youtube.com/embed/6KGUhhGTGrE"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>
                <a href="2022DesignReport.pdf" style={{ width: "100%" }}>
                    <button style={{
                            ...styles.button,
                            ...( isHovering ? styles.activeButton : {}),
                        }}>
                            Jelly Technical Design Report
                    </button>
                </a>
            </div>
        </div>
    )
}

export default PastYear2021;